/* eslint-disable no-console */
import wrapper from 'wrapper';
import trackScrollPosition from './utils/trackScrollPosition';
import isInViewport from './utils/isInViewport';
import AnimationToggle from './components/animation-toggle/animation-toggle';
import sharedVariables from './shared_variables';
import FilterButtons from './components/filter-buttons/filter-buttons';
import Profile from './components/profile/profile';
import FloatingButton from './components/floating-button/floating-button';
import ScrollyTracker from './components/scrolly-tracker/scrolly-tracker';

let hasLogged = false;
const variant = wrapper.select('#variant-b') ? 'b' : 'a';
const filterBtnsContainer = wrapper.select('.filter-buttons__wrapper');

// add tracking to profiles
new ScrollyTracker(wrapper.select('.profile__section'), { sceneSelector: '.profile' });

// add tracking to OJs
wrapper.selectAll('.onward-journey').forEach((li) => {
    li.addEventListener('click', () => wrapper.trackUserAction('onward journey clicked', li.querySelector('a').href));
});

if (sharedVariables.animation_toggle) new AnimationToggle();

wrapper.markPageAsLoaded();
new FilterButtons();
new Profile();
// new FloatingButton('.profile__section', '.floating-button--skip-to-bottom', 'section_2', { scrollTo: true, offset: 1.5 });
new FloatingButton('.profile__section', '.floating-button--back-to-top', 'filter-buttons', { offset: 5.5 });

__lazyLoad();

wrapper.onOptimizedScroll(() => {
    trackScrollPosition();
    if (isInViewport(filterBtnsContainer) && !hasLogged) {
        wrapper.trackUserAction('reached categories box', variant);
        hasLogged = true;
    }
});

// force to top on refresh so as not to cause issues with the parallax effect
window.addEventListener('beforeunload', () => {
    window.scrollTo(0, 0);
});

// add load event for mobile browsers which don't fire beforeunload
window.addEventListener('load', () => {
    setTimeout(() => window.scrollTo(0, 0), 300);
});
